import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';
import { openModal, useModalContext } from '../../../contexts/ModalContext';
import { useCheckoutContext } from '../../../contexts/CheckoutContext';
import { COOKIE_STRIPE_SESSION_ID } from '../../../constants/AppConstants';
import getStripeSessionInfo from '../../../api/stripeSessionInfo';

const cookies = new Cookies();

const useStripeSession = (isEdit: boolean, isSuper: boolean): void => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { dispatch } = useModalContext();
  const { checkoutSessionID, managerPackageID, setManagerPackageID, setSession } = useCheckoutContext();

  const [stripeKey, setStripeKey] = useState<string>(null);
  const [isExpired, setIsExpired] = useState<boolean>(false);

  useEffect(() => {
    if (!isSuper) {
      if (!isEdit && managerPackageID === -1 && !stripeKey) {
        const session = new URLSearchParams(search).get('session');
        const sessionID: string = checkoutSessionID || cookies.get(COOKIE_STRIPE_SESSION_ID);
        if (session) {
          setStripeKey(session);
          setSession(session);
        } else if (sessionID) {
          setStripeKey(sessionID);
        } else {
          openModal({
            dispatch,
            title: 'Session Expired',
            message:
              'It appears the purchased subscription has already been applied to a restaurant. If this is not the case please email our team at info@taptabapp.com so that we can address this issue promptly.',
            onDismiss: () => navigate('/')
          });
        }
      }
    }
  }, [managerPackageID, checkoutSessionID, navigate, search, setSession, stripeKey, isEdit, dispatch, isSuper]);

  useEffect(() => {
    if (stripeKey && managerPackageID === -1 && !isExpired) {
      getStripeSessionInfo(stripeKey)
        .then((info) => {
          if (info.managerPackageIDs.length === 0) {
            setIsExpired(true);
            openModal({
              dispatch,
              title: 'Session Expired',
              message:
                'It appears the purchased subscription has already been applied to a restaurant. If this is not the case please email our team at info@taptabapp.com so that we can address this issue promptly, ' +
                `and make sure to include this session ID in your email. \n \n SESSION ID: ${stripeKey}`,
              onDismiss: () => navigate('/')
            });
          } else {
            setManagerPackageID(info.managerPackageIDs[0]);
            toast.success('Successfully Purchased!', {
              position: toast.POSITION.TOP_RIGHT
            });
          }
        })
        .catch(() => {
          openModal({
            dispatch,
            message:
              'Please email our team at info@taptabapp.com so that we can address this issue promptly, ' +
              `and make sure to include this session ID in your email. \n \n SESSION ID: ${stripeKey}`
          });
        });
    }
  }, [dispatch, isExpired, managerPackageID, navigate, setManagerPackageID, stripeKey]);
};

export default useStripeSession;
